export const NO_SCHOOL_RECORD_FOUND = "There's not a record of this school.";

export const NO_STUDENT_RECORD_FOUND = "There's not a record of this student.";

export const NO_FACULTY_MEMBER_RECORD_FOUND =
  "There's not a record of this faculty member.";
